import { render, staticRenderFns } from "./employeesRoleDialog.vue?vue&type=template&id=1ff611b6&"
import script from "./employeesRoleDialog.vue?vue&type=script&lang=js&"
export * from "./employeesRoleDialog.vue?vue&type=script&lang=js&"
import style0 from "./employeesRoleDialog.vue?vue&type=style&index=0&id=1ff611b6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports